import { setMenuSelected } from '@redux/actions/menuAction';
import Clearfix from 'components/elements/clearfix';
import { COLOR } from 'config';
// import moment from 'moment';
// import { DATE_FORMAT } from 'config';
import slug from 'constants/slug';
import { BaseListContainer } from 'containers/BaseContainer/BaseListContainer';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import styled from 'styled-components';

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

class FacilityemissionPanel extends React.Component {
  static propTypes = {
    facilityId: PropTypes.string.isRequired,
    hideRightHeaderContent: PropTypes.bool,
    dataList: PropTypes.array,
  };

  render() {
    return (
      <div style={{ width: '100%' }}>
        <Clearfix height={8} />
        <FacilityemissionList
          hideRightHeaderContent
          facilityId={this.props.facilityId}
          dataList={this.props.dataList}
        />
      </div>
    );
  }
}

class FacilityemissionList extends BaseListContainer {
  static propTypes = {
    facilityId: PropTypes.string,
    hideRightHeaderContent: PropTypes.bool,
  };

  constructor(props) {
    const funcApi = {};
    const columns = [
      // {
      //   dataField: 'facility.FacilityNameFull',
      //   text: 'Tên cơ sở/dự án',
      //   formatter: (cell, row) => {
      //     return (
      //       <Link to={slug.FACILITY_EMISSTION.VIEW_WITH_ID + row._id}>
      //         <NameContainer>{cell}</NameContainer>
      //       </Link>
      //     );
      //   },
      // },
      // {
      //   dataField: 'facility.industrialArea',
      //   text: '	KCN/CCN',
      //   formatter: (cell, row) => {
      //     return <div>{cell ? cell.Name : ''}</div>;
      //   },
      // },
      // {
      //   dataField: 'facility.district',
      //   text: 'Quận/Huyện',
      //   formatter: (cell, row) => {
      //     return <div>{cell ? cell.Name : ''}</div>;
      //   },
      // },
      // {
      //   dataField: 'facility.sector',
      //   text: 'Ngành/Nghề',
      //   formatter: (cell, row) => {
      //     return <div>{cell ? cell.Name : ''}</div>;
      //   },
      // },
      {
        dataField: 'emissionType',
        text: 'Loại chất thải',
        formatter: (cell, row) => {
          return (
            // <div>{cell ? cell.Name : ''}</div>
            <Link to={slug.FACILITY_EMISSTION.VIEW_WITH_ID + row._id}>
              <NameContainer>{cell ? cell.Name : ''}</NameContainer>
            </Link>
          );

          // return <div>{cell ? cell.Name : ''}</div>;
        },
      },
      {
        dataField: 'DataValue',
        text: 'Giá trị',
        formatter: (cell, row) => {
          return cell ? cell : '';
        },
      },
      {
        dataField: 'url',
        text: 'Đường dẫn (URL)',
        formatter: (cell, row) => {
          return (
            <a href={cell} target='_blank'>
              <NameContainer>{cell}</NameContainer>
            </a>
          );
        },
      },
      {
        dataField: 'reference',
        text: 'Nguồn trích dẫn',
        formatter: (cell, row) => {
          return <div>{cell ? cell : ''}</div>;
        },
      },
    ];
    super(
      props,
      funcApi,
      columns,
      `${slug.FACILITY_EMISSTION.CREATE}?facilityId=${props.facilityId}`,
      'facilityEmission',
      null,
      false
    );

    this.state = {
      ...this.state,
      valueSearch: {
        facility: this.props.facilityId,
      },
      dataList: this.props.dataList,
      isLoading: false,
    };
  }
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FacilityemissionPanel)
);



// WEBPACK FOOTER //
// ./src/containers/Coso/CosoView/FacilityemissionPanel/index.js